
import { Options, Vue } from "vue-class-component";
import { useStore } from "@/store";
import { objCookie } from "@/utils/common";
import {isKtpSelfDoamin} from '@/utils/utils';
import AcademicAffairs from '@/apis/academicAffairsApi'

import {
  getAgencyLists,
  switchAgencyManage,
  switchCampusManage,
} from "@/apis/commonApi/index";
import onlineDataApi from "@/apis/onlineDataApi";
import { UserActionTypes } from "@/store/modules/user/action-types";
import { ElMessage } from "element-plus";

@Options({})
export default class Header_bar extends Vue {
  value: any = [];
  private agencyList: any = [];
  private campusList: any = [];
  private isMenus: boolean = false;
  private otherTile:string = '';
  get userInfo() {
    return useStore().state.user.userInfo.userinfo;
  }

  get schooleinfo() {
    let schoolInfo = useStore().state.user.userInfo.schooleinfo;
    if(location.hostname.includes('sclassroom.com')){
      schoolInfo.name = "演示学校";
    }
    return schoolInfo;
  }

  created(): void {
    window.addEventListener("click", this.setMenus, true);
    if(this.$route.path.indexOf("/inspectopen")>-1){
      this.otherTile = "线下（教室）督导巡课";
    }
    this.init();
  }
  init() {
    this.getAgencyLists();
    this.getCampusLists();
  }
  setMenus() {
    if (this.isMenus) {
      this.isMenus = false;
    }
  }
  errorHandler() {
    return true;
  }
  getRoleName(role: string) {
    if (role) {
      switch (role) {
        case "0":
          return "超级管理员";
        case "1":
          return "管理员";
        case "2":
          return "成员";
        case "3":
          return "院系管理员";
        case "4":
          return "督导";
      }
    }
  }

  handleCommand(command: string) {
    if (command === "/login") {
      objCookie.deleteCookie("jigou-access-token");
      this.$router.push(command);
      location.reload();
    } else {
      this.$router.push(command);
    }
    this.isMenus = false;
  }
  //获取多机构
  getAgencyLists() {
    getAgencyLists().then((res: any) => {
      this.agencyList = res;
    });
  }
  //获取校区
  getCampusLists() {
    onlineDataApi.getCampusLists().then((res) => {
      this.campusList = res as any;
    });
  }
  //切换机构
  switchAgencyManage(item: any) {
    if (item.coid != this.schooleinfo.coid) {
      switchAgencyManage({ coid: item.coid }).then(() => {
        this.$router.push("/home/welcome");
        setTimeout(() => {
          location.reload();
        }, 200);
      });
    }
  }
  //切换校区
  switchCampus(item: any) {
    if (item.id != this.userInfo.campusid) {
      switchCampusManage({ campusid: item.id }).then(() => {
        useStore().dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined);
        this.$router.push("/home/welcome");
        ElMessage.success("变更成功!");
      });
    }
  }
  unmounted() {
    window.removeEventListener("click", this.setMenus);
  }
  //返回到首页
  gotowelcome(){
    location.href = "/#/home/welcome";
    location.reload();
  }

  clearSupervisorData(){
    this.$confirm('清空督导视角缓存之后，如您当前有正在督导课程，则需要重新进入！', '系统提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      AcademicAffairs.clearSupervisorCache({}).then(()=>{
        this.$message.success("已经清空完毕");
      });
    }).catch(() => {

    });
  }
}
